import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  StaysFormErrors,
  StaysWidgetForm
} from '../models/stays-widget.interfaces';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlingService {
  processErrors(
    errors: StaysFormErrors,
    form: FormGroup<StaysWidgetForm>,
    hostElement?: HTMLElement
  ): {
    destinationErrorLabel: string;
    dateError: string;
    travelerError: string;
    roomsError: string;
    maxDatesError: string;
    errorCount: number;
    firstErrorElement: HTMLElement | null;
  } {
    return {
      destinationErrorLabel: errors.destinationErrorLabel,
      dateError: errors.dateError,
      travelerError: errors.travelerError,
      roomsError: errors.roomsError,
      maxDatesError: errors.maxDatesError,
      errorCount: this.countErrors(errors),
      firstErrorElement: this.getFirstInvalidElement(errors, hostElement)
    };
  }

  private countErrors(errors: StaysFormErrors): number {
    return [
      errors.destinationErrorLabel,
      errors.dateError,
      errors.travelerError,
      errors.roomsError,
      errors.maxDatesError
    ].filter((error) => error && error.trim() !== '').length;
  }

  getFirstInvalidElement(
    errors: StaysFormErrors,
    hostElement?: HTMLElement
  ): HTMLElement | null {
    return this.findInvalidControlElement(errors, hostElement);
  }

  private findInvalidControlElement(
    errors: StaysFormErrors,
    hostElement?: HTMLElement
  ): HTMLElement | null {
    const controlMap = [
      {
        check: () => !!errors.destinationErrorLabel,
        selector: '#location-field'
      },
      {
        check: () => !!errors.dateError || !!errors.maxDatesError,
        selector: '#range-date-trigger'
      },
      {
        check: () => !!errors.travelerError,
        selector: '#stays-widget__traveler-selector'
      },
      {
        check: () => !!errors.roomsError,
        selector: '#stays-widget__room-selector'
      }
    ];

    const invalidControl = controlMap.find((item) => item.check());
    if (!invalidControl) return null;

    const root = hostElement || document;
    return root.querySelector(invalidControl.selector) as HTMLElement;
  }
}
